
import { Vue, Component, Watch } from 'vue-property-decorator';
// import SearchBar from '@/components/next/SearchBar.vue';
import { getUser, ifSave, getBaseInfo } from '../api';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
import { List, Lazyload, Dialog, Toast } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast);
@Component({
  components: {
    // SearchBar,
  },
})
export default class User extends Vue {
  // search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  unionid: string | null = '';
  bannerImg: string = '';
  baseInfo: any = {};
  currentMediaType: number = 0; // 0: 绘画, 1: 视频
  inStream: any = ['小学组', '初中组'];

  getStatusClass(enable: string) {
    if (enable === '-1') return 'status-fail';
    if (enable === '0') return 'status-pending';
    return 'status-success';
  }

  @Watch('currentMediaType')
  onMediaTypeChange(val: number) {
    this.refreshList(); // 监听类型变化，重新搜索
  }

  changeMediaType(type: number) {
    if (this.currentMediaType === type) { return; }
    this.currentMediaType = type;
  }

  refreshList() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.loading = true;
    this.onLoad();
  }

  // userInputChange(text: string) {
  //   this.search = text;
  // }

  // clear() {
  //   this.list = [];
  //   this.page = 1;
  //   this.finished = false;
  //   this.search = '';
  //   this.onLoad();
  // }

  async mounted() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
  }
  AppLogin() {
    const token = window.token;
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  onLoad() {
    const unionid = window.localStorage.getItem('unionid');
    const data = {
      unionid,
      token: window.token,
      appkey: window.appkey,
      wdid: window.udid,
      workType: this.currentMediaType === 0 ? 1 : 2,
    };
    getUser(data).then((res: any) => {
      this.list = res.data;
      this.finished = true;
      this.loading = false;
    });
  }
  goDetail(id: any, enable: string) {
    if (enable === '1') {
      this.$router.push(`homeDetail?id=${id}`);
    }
  }
}
